import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 10000 }
  }

  connect() {
    this.refresh = this.refresh.bind(this)
    this.timer = window.setInterval(this.refresh, this.intervalValue)
    document.addEventListener("visibilitychange", this.refresh)
    this.refresh()
  }

  disconnect() {
    window.clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.refresh)
  }

  refresh() {
    if (document.hidden || !this.urlValue) return

    window.fetch(this.urlValue, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then((response) => {
      if (!response.ok) return
      return response.text()
    }).then((html) => {
      if (html) window.Turbo.renderStreamMessage(html)
    }).catch(() => {})
  }
}
